module.exports = __webpack_public_path__ + "img/homeRightImg.8e32b59.webp";